export default {
    formBuilderData: [],
    formBuilderList: [],
    idDocumentExpiryNote: null,
}
